import '../../style/index.less';
import './index.less';
import '../../progress/style';
